.wrapper {
  display: grid;
  grid-template-columns: max-content auto;
  font-size: 14px;
  padding: 10px;
}

.value {
  margin: auto 0;
}
